<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="edit">
          新增公寓
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="" style="margin-right: 10px !important">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="公寓名称"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table
      v-loading="listLoading"
      border
      :data="list"
      @selection-change="setSelectRows"
    >
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="公寓名称"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="所在州"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag>{{ row.province && row.province.title }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="街道"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag>{{ row.city && row.city.title }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="left" label="附近地标" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag>{{ row.basic && row.basic.landmark }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="地标距离"
        prop="basic.distance"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="价格"
        prop="basic.price"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="标签"
        prop="basic.tag"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="公寓概况"
        prop="basic.description"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="公寓设施"
        prop="basic.facility"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.create).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="操作"
        fixed="right"
        show-overflow-tooltip
        width="120"
      >
        <template #default="{ row }">
          <!-- <el-button type="text" @click="detail(row)">详情</el-button> -->
          <el-button type="text" @click="edit(row)">编辑</el-button>
          <el-button type="text" @click="deleteAction(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { findBuildingList, removeBuilding } from '@/api/apartment'
import Edit from './edit'
export default {
  name: 'Building',
  components: { Edit },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/apartment/building') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    edit(row) {
      this.$refs['edit'].showEdit(row)
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    deleteAction(row) {
      this.$baseConfirm(`你确定要删除该公寓吗？`, null, async () => {
        await removeBuilding({ apartmentId: row.apartmentId })
        this.$baseMessage(
          '删除公寓成功',
          'success',
          false,
          'vab-hey-message-success'
        )
        await this.fetchData()
      })
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findBuildingList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
